import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_SEARCH_HISTORY = "SET_SEARCH_HISTORY";

export const EQUIPMENT_CODE = "EQUIPMENT_CODE";
export const LIQUID_BOTTLE_CODE = "LIQUID_BOTTLE_CODE";
